import { get, post } from './request'

// 登录发送验证码
function getLoginVerificationCode(data) {
  return post('/channel_admin/login/send_message', data)
}

// 登录
function login(data) {
  return post('/channel_admin/user_login', data)
}

// 令牌认证
function tokenValidate(params) {
  return get('/common_api/token_auth/channel_admin', params)
}

// 查询合作商站点信息
function getStationInfo(params) {
  return get('/common_api/partner_infos', params)
}

// 统一登录
function requestLoginVerificationCode(data) {
  return post('/unify_user/login/send_message', data)
}

// 渠道共有地址发送短信
function requestPublicLoginSendMes(data) {
  return post('/unify_user/private_login/send_message', data)
}

// 渠道共有地址短信登录
function requestPublicLogin(data) {
  return post('/unify_user/private_login/message_login', data)
}

// 重置密码
function requestResetPwd(data) {
  return post('/channel_admin/login/forget_pwd/reset_pwd', data)
}

// 重置密码发送验证码
function requestResetPwdSendCode(data) {
  return post('/channel_admin/login/forget_pwd/send_message', data)
}

// 密码登录
function requestLoginPwd(data) {
  return post('/channel_admin/user_pwd_login', data)
}

function requestVerificationCodeLogin(data) {
  return post('/unify_user/login/message_login', data)
}

function requestUserIdentityList(params) {
  return get('/unify_user/identities', params)
}

function requestChildrenSysToken(params) {
  return get('/unify_user/subsystem/token', params)
}

function requestUserTypeList() {
  return get('/unify_user/user_type')
}

// 获取渠道名称
function getChannelBackgroundName() {
  return get('/channel_admin/admin_title')
}

// 发送日志到企业微信机器人
function postLogRobot(params) {
  return post('/common_api/qywx', params)
}

// 账户一体化过来的鉴权，获取登陆信息
function requestUnifyServiceAuth() {
  return post('/channel_admin/unify_service/auth')
}
// 账户一体化过来的鉴权，获取登陆信息
function getUserId(params) {
  return get('/common_api/unify_service/user', params)
}

export {
  requestPublicLogin,
  requestPublicLoginSendMes,
  requestLoginVerificationCode,
  requestVerificationCodeLogin,
  requestUserIdentityList,
  requestChildrenSysToken,
  getLoginVerificationCode,
  login,
  tokenValidate,
  getStationInfo,
  requestUserTypeList,
  requestLoginPwd,
  requestResetPwdSendCode,
  requestResetPwd,
  getChannelBackgroundName,
  postLogRobot,
  requestUnifyServiceAuth,
  getUserId,
}
